import classNames from "classnames";
import { AnimationsPropTypes } from "./type";

function Animations(props: AnimationsPropTypes) {}

Animations.CircleScaleIn = function (props: AnimationsPropTypes) {
  return (
    <div className={classNames("circleScaleInAnimation", { "circleScaleInAnimation--warning": props.isWarning })}>
      <div className="circleScaleInAnimation--circle"></div>
      <div className="circleScaleInAnimation--circle"></div>
      <div className="circleScaleInAnimation--circle"></div>
    </div>
  );
};

export default Animations;
